import { el, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

import {
  applyTraits
} from '/programs/utilities/language.js';

import { InputValueGetter, InputValueSetter } from '../traits/value-accessors.js';

class EmailInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-text-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = el('input', {
      type: 'email'
    });

    return this.input;

  }

  update(options, fieldRow) {

    const attributes = {
      required: options.required,
      placeholder: options.placeholder || '',
      name: fieldRow.label
    };

    setAttr(this.input, attributes);

  }

}

export default applyTraits(EmailInputRenderer, [InputValueGetter, InputValueSetter]);